import html from './publications-usr-add.html';
import lang from './publications-usr-add.lang.json';
import * as mixins from '../../../client/globals/mixins.js';
import * as directives from '../../../client/globals/directives.js';
import * as validators from '../../../client/globals/validators.js';
import server from '../../../client/asis-server.js';


export default {
    template: html,

    i18n: {
        messages: lang
    },

    mixins: [mixins.loadDataOnCreate, directives.label_required, validators.vuelidate],

    data() {
        return {
            publication: {},
            file: null,
            journals: null,
            submit_progress: null,
            submit_error: null,
        };
    },

    validations() {
        // regex pattern for "last_name, first_name"
        const regex_last_first = /^[A-Za-zÀ-ž'’\- ]+, [A-Za-zÀ-ž'’\- ]+$/;
        return {
            publication: {
                first_author: {
                    required: validators.required,
                    format: validators.regex(regex_last_first),
                },
                title: {
                    required: validators.required
                },
                journal: {
                    required: validators.required,
                },
                open_access: {
                    required: validators.required,
                },
                arxiv: {
                    required: validators.required
                },
                file: {
                    required: validators.required
                },
            }
        };
    },


    methods: {
        load() {
            server.request(
                'publications-usr', 'publications-journal-list', {}, null,
                (data)=>{
                    this.journals = data;
                }
            );
        },

        submit(event) {
            // check if the form validates
            if (this.$v.$invalid) return;

            this.submit_progress = 0;
            this.submit_error = null;
            server.request(
                'publications-usr', 'publications-add', 
                this.publication, null,
                (result)=>{
                    this.$router.back();
                },
                (error)=>{
                    this.submit_error = error;      // show error message
                },
                {onProgress:(perc)=>{
                    this.submit_progress=perc
                }, timeout:600000}
            ).then(()=>{
                this.submit_progress = 0;       // hide upload progress bar
            });
        },

    },

};

